import { render, staticRenderFns } from "./TagList.vue?vue&type=template&id=417dcd98&scoped=true&"
import script from "./TagList.vue?vue&type=script&lang=js&"
export * from "./TagList.vue?vue&type=script&lang=js&"
import style0 from "./TagList.vue?vue&type=style&index=0&id=417dcd98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417dcd98",
  null
  
)

export default component.exports